import { BrowserRouter as Router, Navigate, Routes, Route, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import DocumentView from "./components/DocumentView";
import SearchBox from "./components/SearchBox";
import DocumentList from "./components/DocumentList";
import ArchiveLayout from "./components/ArchiveLayout";
import PersonList from "./components/PersonList";
import { PageMenu, PageView, Frontpage } from "./components/Pages";
import { Container } from "./components/Elements";

import './css/index.css';
import logo from './img/arnastofnun_logo.png';

import config from "./config";
import MatomoVeftalning from "./components/MatomoVeftalning";
import SiteFooter from "./components/SiteFooter";

function App() {
	const [currentLang, setCurrentLang] = useState();

	const setLang = (lang) => {
		setCurrentLang(lang);

		try {
			window.localStorage.setItem('currentLang', lang);
		}
		catch(e) {}
	}

	const languages = [
		['is', 'IS'],
		['dk', 'DA'],
		['no', 'NO'],
		['en', 'EN']
	];

	useEffect(() => {
		fetch(config.apiRoot+'web/translations/?limit=2000')
			.then(res => res.json())
			.then(json => {
				json.results.forEach(item => {
					window.langData[item.language] = window.langData[item.language] || {};
					window.langData[item.language][item.value] = item.trans;
				});
					
			if (window.localStorage.getItem('currentLang')) {
				setLang(window.localStorage.getItem('currentLang'));
			}
			else {
				window.localStorage.setItem('currentLang', 'is');
				setLang('is');
			}
			});
	}, []);

	return <div className="App">
		<Router>
			<div className="bg-sam_theme print:hidden">

				<Container className="relative">

					<div className="block flex pt-10 pb-2 gap-5 items-start">
						<img src={logo} className="max-w-[80px]" id="siteLogo" />
						<Link className="hover:no-underline" to={'/'}><h1 className="font-lido text-white text-4xl leading-[0.85]">Diplomatarium Arnamagnæanum<br/><small className="text-xl">{window.l('Charters from the collection of Árni Magnússon')}</small></h1></Link>
					</div>

					<div className="absolute top-5 right-5 flex gap-5">
						{
							languages.map((lang, index) => <button key={index} className={'text-white'+(lang[0] == currentLang ? ' font-bold' : '')} onClick={() => setLang(lang[0])}>{lang[1]}</button>)
						}
					</div>

					<PageMenu className="pt-4 pb-10" currentLang={currentLang} />

				</Container>

			</div>

			<Routes>

				<Route path="bref"element={<Navigate to="/archive" />} />

				<Route path="archive" element={<ArchiveLayout currentLang={currentLang} />}>
					<Route path=":docId/:tab?" element={<DocumentView />}/>
				</Route>

				<Route path="einstaklingar" element={<PersonList />}/>

				<Route path="/" element={<Frontpage currentLang={currentLang} />} />

				<Route path="forsida" element={<Frontpage currentLang={currentLang} />} />

				<Route path="*" element={<PageView currentLang={currentLang} />} />

			</Routes>

			<MatomoVeftalning />

		</Router>

		<SiteFooter />

	</div>;
}

export default App;
